var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableConfig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#table-config_svg__clip0_321_3173)",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 11.5l1 7M7.662 19.084v4.182M1.764 23.266l.738-4.182M12.085 15.5v7.629M10.989 23.129h2.288",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.5h9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 7.99c.348-.744 1.045-1.363 1.858-1.24l1.394.124c.581 0 1.046-.247 1.51-.62.349-.37.58-.99.58-1.61l-.115-1.487c0-.867.464-1.61 1.161-1.982.697-.372 1.626-.124 2.207.495l.93 1.115c.348.372.928.62 1.393.62.58 0 1.046-.248 1.394-.62l.93-1.115c.58-.62 1.393-.867 2.206-.495.697.371 1.278 1.115 1.162 1.982l-.117 1.487c0 .62.233 1.115.581 1.61.349.373.93.62 1.51.62l1.394-.123c.813 0 1.51.495 1.858 1.239.349.743.116 1.734-.464 2.354l-1.046.991c-.348.372-.58.991-.58 1.487 0 .496.232 1.115.58 1.487l1.046.991c.58.62.813 1.487.464 2.354-.348.744-1.045 1.363-1.858 1.24l-1.394-.124c-.58 0-1.045.247-1.51.62-.348.37-.58.99-.58 1.61",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12a4 4 0 00-8 0M2.5 18.5H8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "table-config_svg__clip0_321_3173"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgTableConfig;